var _metadata, _defs, _linearGradient, _linearGradient2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeasi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg11",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 200 200",
    y: "0px",
    x: "0px",
    viewBox: "48.19 40 103.62 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata15"
  }, /*#__PURE__*/React.createElement("rdfRdf", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs622914"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    spreadMethod: "pad",
    y2: "30%",
    x2: "-10%",
    y1: "120%",
    x1: "30%",
    id: "3d_gradient2-logo-5A19AC1CE5B84D74A7441A7A45E922F5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop622891",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop622893",
    stopOpacity: 1,
    stopColor: "#000000",
    offset: "100%"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "rotate(-30)",
    spreadMethod: "pad",
    y2: "30%",
    x2: "-10%",
    y1: "120%",
    x1: "30%",
    id: "3d_gradient3-logo-5A19AC1CE5B84D74A7441A7A45E922F5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop622896",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop622898",
    stopOpacity: 1,
    stopColor: "#cccccc",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop622900",
    stopOpacity: 1,
    stopColor: "#000000",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ed583b"
    },
    d: "m 100.02688,40.001725 c -0.004,0 -3.02441,1.741474 -6.711296,3.869851 -3.686565,2.128377 -6.707452,3.882999 -6.713224,3.899095 -0.0057,0.01605 7.796395,4.536236 17.33779,10.044825 l 17.34806,10.015324 v 20.048606 c 0,11.026669 0.01,20.048604 0.0224,20.048604 0.0125,0 3.04506,-1.74468 6.73888,-3.87729 l 6.72092,-3.87992 V 60.051164 L 117.4038,50.025578 C 107.8547,44.511603 100.03715,39.999993 100.03073,39.999993 Z m -17.104992,9.987748 c -0.02924,0.0018 -7.827819,4.492755 -17.329455,9.980052 -9.501636,5.486848 -17.304444,9.998009 -17.339075,10.024944 l -0.06311,0.0485 0.0096,7.764329 0.0096,7.763688 L 59.88709,78.8289 c 6.422711,-3.707921 12.616474,-7.283989 13.763776,-7.946462 1.147431,-0.662857 3.701508,-2.137611 5.676548,-3.277923 1.974655,-1.139927 3.598129,-2.072711 3.607043,-2.072711 0.0093,0 7.825895,4.508788 17.370503,10.019814 9.5446,5.510769 17.36023,10.019813 17.36793,10.019813 0.008,0 0.0103,-3.499688 0.005,-7.777155 l -0.006,-7.777797 -17.34742,-10.015325 C 90.784081,54.49295 82.953696,49.987113 82.924196,49.989037 Z m 55.473242,12.544006 -0.0624,-0.03459 -0.002,20.067203 -10e-4,20.067208 -17.08127,9.85884 c -9.39454,5.42234 -17.20953,9.9326 -17.36537,10.02302 l -0.28418,0.16367 6.71515,3.87909 c 3.69298,2.1337 6.73246,3.87979 6.75491,3.88056 0.0224,6.4e-4 7.84834,-4.50629 17.39102,-10.01532 l 17.34997,-10.01661 -0.008,-20.067849 -0.008,-20.067845 -6.66769,-3.851317 c -3.66733,-2.117988 -6.69591,-3.866645 -6.7299,-3.8855 z m -55.473242,7.173042 c -0.0107,0.0014 -7.829743,4.51379 -17.374988,10.026868 L 48.19051,89.758333 v 40.117087 l 6.715789,3.87736 c 3.694069,2.13261 6.726691,3.87729 6.738876,3.87729 0.01284,0 0.02318,-9.0213 0.02354,-20.04796 l 3.57e-4,-20.047968 17.348053,-10.015324 c 9.542038,-5.508589 17.343563,-10.029434 17.338433,-10.045466 -0.0057,-0.01641 -3.02621,-1.771104 -6.712583,-3.899416 -3.68618,-2.127992 -6.710658,-3.868056 -6.721561,-3.866645 z m -4.128684,22.39259 c -0.01462,0.0018 -3.028006,1.738654 -6.695909,3.859848 -3.668031,2.121578 -6.688213,3.869851 -6.712582,3.885884 -0.03352,0.02246 -0.04315,4.410727 -0.04315,20.065277 v 20.03642 l 0.133713,0.0863 c 0.07346,0.0471 7.881048,4.55836 17.349977,10.0243 9.468929,5.46582 17.237107,9.94029 17.262757,9.94286 0.0257,0.002 3.06437,-1.73686 6.75299,-3.86446 3.68836,-2.128 6.70681,-3.87697 6.70681,-3.88659 3.5e-4,-0.01 -7.76112,-4.49847 -17.248011,-9.97493 -9.486886,-5.47678 -17.300596,-9.99159 -17.364727,-10.03007 l -0.115885,-0.0706 v -20.03963 c 0,-11.02154 -0.01212,-20.038344 -0.02674,-20.03642 z m 3.57068,22.508029 c -0.04208,-0.0164 -0.04956,1.1303 -0.04956,7.75022 v 7.76946 l 17.351901,10.01789 c 9.543325,5.51006 17.369215,10.02238 17.391665,10.02687 0.0217,0.004 7.84641,-4.49879 17.38717,-10.00763 l 17.34677,-10.01661 0.009,-7.77587 c 0.005,-4.27702 0.003,-7.77652 -0.004,-7.77652 -0.008,0 -7.82397,4.50879 -17.36921,10.01982 L 117.07321,134.63201 99.7444,124.62759 C 90.213264,119.12516 82.3925,114.61034 82.365565,114.60393 Z",
    id: "icon"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeasi);
export default __webpack_public_path__ + "static/media/iconeasi.81e6d25664ca8b01fce9b687c6f43497.svg";
export { ForwardRef as ReactComponent };